import { HttpClient } from '@angular/common/http';
import { environment } from '@app/environment';
import { map } from 'rxjs/operators';
import type { RemotePage } from '../core/data/remote-pages';
import { APIReference } from './api-result.model';
import { Reference, toReference } from './company.model';

/** One page of the references to a company, as the backend pages them. */
export const fetchReferences = (
  http: HttpClient,
  companyId: string,
  page: number,
  resultsPerPage: number
) =>
  http
    .post<RemotePage<APIReference>>(`${environment.apiBase}/fetchReference`, {
      method: 'fetchReference',
      data: { companyId, page, resultsPerPage },
    })
    .pipe(
      map(
        ({ totalCount, data }): RemotePage<Reference> => ({
          totalCount,
          data: data.map(toReference),
        })
      )
    );
